import { Cancel, Check } from '@mui/icons-material';
import { Box, Grid, IconButton, Typography } from '@mui/material';
import { GridKeyboardArrowRight } from '@mui/x-data-grid';
import { sahinConfirmDialog } from '@sahinyazilim/sahinyazilim-components';
import { useTranslation } from 'react-i18next';
import { OrderStatus } from 'common/model/OrderStatus';
import { OrderSteps } from 'common/model/OrderSteps';
import { updateAPI } from 'common/helper/apiHelpers';
import { AdminTablePaths } from 'common/model/AdminTablePaths';
import { useStyles } from '../OrderList.styles';

interface OrderStatusControlProps {
  params: any;
  onMutate: () => void;
}

export const OrderStatusControl = ({
  params,
  onMutate,
}: OrderStatusControlProps) => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const status = params?.row?.status as OrderStatus;

  const handleConfirm = (action: OrderSteps) => () => {
    sahinConfirmDialog({
      title: t(`confirmDialog.title.${action}`),
      message: t(`confirmDialog.description.${action}`),
      confirmText: 'Onayla',
      cancelText: 'Vazgeç',
      onConfirm: () => setOrderStatus(action),
    });
  };

  const setOrderStatus = (action: OrderSteps) => {
    const id = params?.row?.id;
    const status = {
      [OrderSteps.APPROVAL]: OrderStatus.PREPARING,
      [OrderSteps.CANCEL]: OrderStatus.REJECTED,
      [OrderSteps.PREPARING]: OrderStatus.ON_WAY,
      [OrderSteps.ON_WAY]: OrderStatus.DELIVERED,
    }[action];

    updateAPI(AdminTablePaths.ORDER, id, { status }).then(() => {
      onMutate();
    });
  };

  return (
    <Box width={170}>
      <Grid alignItems="center" container>
        {status === OrderStatus.PENDING && (
          <>
            <IconButton
              onClick={handleConfirm(OrderSteps.APPROVAL)}
              className={classes.textButton}
            >
              <Check />
            </IconButton>
            <IconButton className={classes.textButton}>
              <Cancel onClick={handleConfirm(OrderSteps.CANCEL)} />
            </IconButton>
          </>
        )}
        {(status === OrderStatus.REJECTED ||
          status === OrderStatus.DELIVERED) && (
          <Grid alignItems="center" py={1} container>
            <Typography textAlign="center">
              {status === OrderStatus.DELIVERED
                ? t('orderStatus.delivered')
                : t('orderStatus.rejected')}
            </Typography>
          </Grid>
        )}
        {(status === OrderStatus.ON_WAY ||
          status === OrderStatus.PREPARING) && (
          <Grid
            xs={12}
            className={classes.textButton}
            onClick={handleConfirm(status as unknown as OrderSteps)}
            justifyContent="center"
            alignItems="center"
            item
            container
          >
            <Typography textAlign="center">
              {t(`orderStatus.${status.toLowerCase()}`)}
            </Typography>
            <GridKeyboardArrowRight fontSize="medium" />
          </Grid>
        )}
      </Grid>
    </Box>
  );
};
